import { createFileRoute } from '@tanstack/react-router'

import { ChangePaymentMethodPage } from '~/boundedContext/subscription/pages/change-payment-method-page'

import { changePaymentMethodSearchSchema } from '../../-schemas/change-payment-method-schema'

export const Route = createFileRoute('/_main-layout/settings/subscription/change-payment-method')({
  component: ChangePaymentMethodPage,
  validateSearch: search => changePaymentMethodSearchSchema.parse(search),
})
